export default __webpack_public_path__ + "assets/images/4440d4981227ea38cbf5050d2e2ae4fa.svg";